export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20overhead%20flat%20lay%20of%20diverse%20fashion%20items%20including%20sneakers%20clothing%20and%20accessories%20neatly%20arranged%20in%20organized%20rows%20on%20a%20warm%20cream%20surface%2C%20soft%20even%20lighting%2C%20editorial%20product%20photography%2C%20clean%20minimal%20aesthetic%2C%20harmonious%20composition%2C%20muted%20warm%20tones&width=1800&height=900&seq=cta-flatlay-v2-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-foreground-950/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col items-start max-w-2xl">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-[1.1] lowercase tracking-tight">
            ready to upgrade your shopping?
          </h2>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center gap-3 px-8 py-4 bg-background-50 rounded-full text-base font-semibold text-foreground-950 hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Access Database Now
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950">
              <i className="ri-arrow-right-line text-sm text-background-50"></i>
            </div>
          </a>

          <p className="mt-6 text-lg text-background-200 max-w-md leading-relaxed">
            Join thousands of smart shoppers using Hipobuy spreadsheets to find better products at better prices.
          </p>
        </div>
      </div>
    </section>
  );
}